// routes/_app.profile.edit._index.tsx
import type { ClientLoaderFunctionArgs } from 'react-router'

const getClientModule = () =>
  import('src/clientRoutes/_app.profile.edit._index')

export const handle = { name: 'profile/edit/' }

export function loader() {
  return null
}

export async function clientLoader(args: ClientLoaderFunctionArgs) {
  const { loader } = await getClientModule()
  return loader(args)
}

clientLoader.hydrate = true

export default function Page() {
  return null
}
